import { takeLatest, put, call, all, select } from 'redux-saga/effects';

import Experience from '../experience';
import PinnedContainerApi from './pinned-container-api';
import PinnedContainerActions from './pinned-container-actions';

function* fetchPinnedContainersHandler({ payload: { channelId } }) {
  const experience = yield select(Experience.Selectors.experience);
  const {
    id: campaignId,
    typeRef: { id: campaignTypeRef },
  } = experience;

  const response = yield call(PinnedContainerApi.fetch, campaignId, campaignTypeRef, channelId);
  if (response.error) yield put(PinnedContainerActions.fetchFailure(response.error));
  yield put(PinnedContainerActions.fetchSuccess(response));
}

export default function* pinnedContainerSagas() {
  yield all([takeLatest(PinnedContainerActions.fetch.getType(), fetchPinnedContainersHandler)]);
}
